import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useDispatch } from 'react-redux';
import { AppDispatch } from './redux/store';
import { verifyIpAddress } from './redux/slices/authSlice';
import { toast, ToastContainer } from 'react-toastify';

const IPVerification = () => {
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('Verifying your IP address...');
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {
        const verifyIP = async () => {
            try {
                const params = new URLSearchParams(location.search);
                const token = params.get('token');

                if (!token) {
                    setStatus('error');
                    setMessage('Token not found');
                    return;
                }

                dispatch(verifyIpAddress(token)).then((action: any) => {
                    if (action?.payload?.success) {
                        setStatus('success');
                        setMessage(action?.payload?.message);
                        toast.dismiss()
                        toast.success(action?.payload?.message)
                        setTimeout(() => navigate('/login'), 3000);
                    } else {
                        toast.dismiss()
                        toast.error(action?.payload)
                    }
                })
            } catch (error) {
                setStatus('error');
                setMessage(error.response?.data?.message || error.message || 'Verification failed');
            }
        };

        verifyIP();
    }, [location, navigate]);

    return (
        <div className="relative w-full h-screen bg-cover bg-center flex flex-col items-center justify-center bg-[url('/src/assets/images/bg.png')] dark:bg-[url('/src/assets/images/darkbg.png')]">
            <div className="w-full bg-[#FFFFFF80] backdrop-blur-lg   dark:bg-[#18191D80] border dark:border-[#23262F99] border-[#FFFFFF99] rounded-lg p-6 max-w-lg  dark:text-white overflow-hidden">
                <div className="bg-gradient-to-r from-[#237249] to-[#35C66B]  text-transparent p-4 text-white">
                    <h1 className="text-[20px] font-bold text-center dark:text-white">IP Address Verification</h1>
                </div>

                <div className="px-8 pt-8">
                    {status === 'verifying' && (
                        <div className="flex flex-col items-center space-y-4">
                            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-indigo-600"></div>
                            <p className="text-gray-700 text-center dark:text-gray-300 ">{message}</p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="flex flex-col items-center space-y-4">
                            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-green-100">
                                <CheckCircleIcon className="h-10 w-10 text-green-600" />
                            </div>
                            <h2 className="text-xl font-semibold dark:text-white text-black">Verification Successful!</h2>
                            <p className="text-gray-700 dark:text-gray-300  text-center">{message}</p>
                            <p className="text-sm text-gray-600 dark:text-gray-300 text-center">You'll be redirected shortly...</p>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="flex flex-col items-center space-y-4">
                            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-red-100">
                                <ExclamationTriangleIcon className="h-10 w-10 text-red-600" />
                            </div>
                            <h2 className="text-xl font-semibold dark:text-white text-black">Verification Failed</h2>
                            <p className="text-gray-500 dark:text-gray-300 text-center">{message}</p>
                            <button
                                onClick={() => window.location.href = '/login'}
                                className="bg-gradient-to-r from-[#237249] to-[#35C66B] text-white p-3 rounded-lg w-full mt-6 flex items-center justify-center hover:opacity-90 transition-opacity disabled:opacity-70"
                            >
                                Return to Login
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default IPVerification;